import { StarIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import BasicArticle from "components/Article/Basic";
import Badges from "components/Badges";
import SpinnerMedium from "components/Spinner/Medium";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DoctorProfile } from "../../Doctor/DoctorDetail";
import { EventCard } from "../../Clinic/ClinicDetail/ClinicEventList";
import TopNav from "common/components/TobNav";
import { staffClient } from "common/apis/staff";
import { UrlUtils } from "components/Utils/url";
import BottomBookmarkBar from "common/components/BottomBookmarkBar";
import { formatKoreanAddress } from "components/Form/KoreanAddressInput";
import numeral from "numeral";
import { formatDate } from "components/Table/Simple/presets";
import { BuildingOfficeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useModal } from "components/Modal/Simple";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

export const ReviewPhotoCard = ({ url, idx, type }) => {
    return (
        <div className="w-40 h-40 relative rounded-md overflow-hidden cursor-pointer" onClick={(e) => {
            // e.preventDefault();
            // e.stopPropagation();
            // window.open(url, 'newWindow', 'width=1280, height=720, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
        }}>
            <img
                key={idx}
                src={UrlUtils.convertCdnUrl(url)}
                className="w-full h-full object-cover shadow-md"
                alt={`procedure_img_${idx}`}
            />
            <span className="absolute bg-gray-600 left-0 bottom-0 w-5 h-5 text-white font-semibold text-xs text-center content-center rounded-tr-md">
                {type}
            </span>
        </div>
    )
}

export const PhotoModalContent = ({ beforePhotos, afterPhotos, onCloseClicked = (e) => { } }) => {
    return (
        <div className="w-full h-full">
            <div
                onClick={onCloseClicked}
                className="absolute top-2 right-2 cursor-pointer z-50"
            >
                <XMarkIcon className="size-12 text-pink-500" />
            </div>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Navigation, Pagination]}
                className="w-full h-full object-contain"
            >
                {!_.isEmpty(beforePhotos) &&
                    beforePhotos.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img src={UrlUtils.convertCdnUrl(image.url)} alt="photo" className="w-full h-full object-contain" />
                            <span className="absolute bg-gray-600 left-0 bottom-0 w-5 h-5 text-white font-semibold text-xs text-center content-center rounded-tr-md">
                                {"전"}
                            </span>
                        </SwiperSlide>
                    ))
                }
                {!_.isEmpty(afterPhotos) &&
                    afterPhotos.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img src={UrlUtils.convertCdnUrl(image.url)} alt="photo" className="w-full h-full object-contain" />
                            <span className="absolute bg-gray-600 left-0 bottom-0 w-5 h-5 text-white font-semibold text-xs text-center content-center rounded-tr-md">
                                {"후"}
                            </span>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export const reviewPhotoModalStyles = {
    styles: {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 120,
        },
        content: {
            position: "fixed", // 화면 정중앙 정렬
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            marginTop: 0,
            width: "100vw",
            height: "100dvh", // 전체 화면 높이
            maxWidth: "100vw",
            maxHeight: "100dvh",
            border: "none",
            backgroundColor: "black",
            padding: 0, // 내부 여백 제거
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden", // 스크롤 제거
        }
    }
}
const ReviewDetail = () => {
    const { reviewId } = useParams();
    const [reviewInfo, setReviewInfo] = useState(null);
    const navigate = useNavigate();
    const { Modal: PhotoModal, openModal, closeModal } = useModal(reviewPhotoModalStyles);

    useEffect(() => {
        if (reviewId === "pv") {
            console.log("[ReviewDetil] reviewId is empty it's maybe preview page");
            console.log("[ReviewDetil] try get from localstorage");
            const tempReviewInfoStr = localStorage.getItem("tempReviewInfo");
            if (_.isNil(tempReviewInfoStr)) {
                console.log("[ReviewDetil] tempReviewInfo is empty");
                return;
            }
            const tempReviewInfo = JSON.parse(tempReviewInfoStr);
            console.log("[ReviewDetil] tempReviewInfo", tempReviewInfo);
            setReviewInfo(tempReviewInfo);
        }
        fetchReviewInfo();
    }, [reviewId]);

    const fetchReviewInfo = async () => {
        if (_.isNil(reviewId)) {
            return;
        }
        try {
            const ret = await axios.get(`https://rest.miview.shop/public/reviews/${reviewId}`);
            // const ret = await staffClient.get(`/review/${reviewId}`);
            console.log("[fetchReviewInfo] ret", ret.data);
            setReviewInfo(ret.data);
        } catch (e) {
            console.error("[fetchReviewInfo] error", e);
        }
    }

    console.log("[ReviewDetil] review", reviewInfo);

    if (_.isNil(reviewInfo)) {
        return <SpinnerMedium />;
    }

    return (
        <div className="pb-16">
            <TopNav
                pages={[
                    {
                        name: "탐색",
                        path: "/contents"
                    },
                    {
                        name: "리뷰",
                        path: "/contents?tabId=reviews"
                    },
                    {
                        name: reviewInfo.title
                    }
                ]}
                disablePlus={true}
            />
            <div className="flex flex-col">
                {/* <div>
                <img src={UrlUtils.convertCdnUrl(reviewInfo.cardImage)} alt={reviewInfo.title} />
            </div> */}
                <div className="border-t border-gray-200"></div>
                <div>
                    <div className="p-5">
                        <span className="font-bold text-lg">
                            {reviewInfo.title}
                        </span>
                        <div className="flex items-center mt-2">
                            <StarIcon className="w-4 h-4 text-yellow-400" />
                            <span className="text-gray-500 text-xs">
                                {numeral(reviewInfo.rating).format("0.0")}
                            </span>
                            <h1 className="text-xs text-gray-500 ps-1">
                                {'·'}
                            </h1>
                            <h1 className="text-xs text-gray-500 ps-1">
                                {formatDate(reviewInfo.created_at)}
                            </h1>
                        </div>
                    </div>
                </div>
                {(!_.isEmpty(reviewInfo.treatments)) && (
                    <div>
                        <div className="border-t border-gray-200">
                            <div className="p-5">
                                <div className="font-semibold">
                                    시술명
                                </div>
                                <div className="mt-3">
                                    <Badges
                                        items={reviewInfo.treatments.map((item) => item.name)}
                                        isRemovable={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {(!_.isEmpty(reviewInfo?.beforePhotos) || !_.isEmpty(reviewInfo?.afterPhotos)) && (
                    <div>
                        <div className="border-t border-gray-200"></div>
                        <div className="p-5 cursor-pointer" onClick={() => { openModal() }}>
                            <div className="font-semibold">
                                시술사진
                            </div>
                            <div className="mt-3 overflow-auto">
                                <div className="flex space-x-3 pb-3 min-w-max">
                                    {reviewInfo.beforePhotos.map((file, idx) => (
                                        <ReviewPhotoCard
                                            key={idx}
                                            url={file?.url}
                                            idx={idx}
                                            type="전"
                                        />
                                    ))}
                                    {reviewInfo.afterPhotos.map((file, idx) => (
                                        <ReviewPhotoCard
                                            key={idx}
                                            url={file?.url}
                                            idx={idx}
                                            type="후"
                                        />
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>
                )}
                <div className="border-t border-gray-200"></div>
                <div className="p-5">
                    <div className="font-semibold">
                        리뷰내용
                    </div>
                    <div className="mt-3">
                        <BasicArticle>
                            <div className="text-sm leading-normal">
                                {reviewInfo.content}
                            </div>
                        </BasicArticle>
                    </div>
                </div>
                {/* <div className="border-t border-gray-200"></div>
            <div>
                <div className="p-5">
                    <div className="font-semibold">
                        상세정보
                    </div>
                </div>
                {reviewInfo.detailImages.map((url, idx) => {
                    return (
                        <div>
                            <img src={UrlUtils.convertCdnUrl(url)} alt={`detail_img_${idx}`} />
                        </div>
                    )
                })}
            </div> */}
                {reviewInfo.event && (
                    <div>
                        <div className="border-t border-gray-200"></div>
                        <div className="p-5 cursor-pointer" onClick={() => {
                            navigate(`/contents/event/${reviewInfo.event.id}`);
                        }}>
                            <div className="font-semibold">
                                이벤트정보
                            </div>
                            <div className="mt-3">
                                <EventCard event={reviewInfo.event} />
                            </div>
                        </div>
                    </div>
                )}
                <div>
                    <div className="border-t border-gray-200"></div>
                    <div className="p-5 cursor-pointer" onClick={() => {
                        navigate(`/contents/clinic/${reviewInfo.clinic.id}`);
                    }}>
                        <div className="font-semibold">
                            의원 정보
                        </div>
                        <div className="flex mt-3 items-center">
                            {!_.isEmpty(reviewInfo.clinic.profileImage) ?
                                <img
                                    src={UrlUtils.convertCdnUrl(reviewInfo?.clinic?.profileImage?.url)}
                                    alt="profileImage"
                                    className="h-24 w-24 p-2 object-center"
                                /> :
                                <div className="flex justify-center text-pink-300 size-24">
                                    <div className="flex justify-center ring ring-inset ring-pink-300 ring-[6px] rounded-full size-20 self-center">
                                        <BuildingOfficeIcon className="size-14 self-center" />
                                    </div>
                                </div>
                            }
                            <div className="p-2">
                                <div className="text-lg font-bold self-center">
                                    {reviewInfo.clinic.name}
                                </div>
                                <div className="text-sm text-gray-500 self-center">
                                    {formatKoreanAddress(reviewInfo?.clinic?.address)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!_.isEmpty(reviewInfo.doctors) && (
                    <div>
                        <div className="border-t border-gray-200"></div>
                        <div className="p-5 cursor-pointer">
                            <div className="font-semibold">
                                의사 정보
                            </div>
                            {reviewInfo.doctors.map((doctor, idx) => (
                                <div onClick={() => {
                                    navigate(`/contents/doctor/${doctor.id}`);
                                }}>
                                    <DoctorProfile
                                        key={idx}
                                        doctor={doctor}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <BottomBookmarkBar
                clinicId={Number(reviewInfo.clinic.id)}
                bookmarkableType="REVIEW"
                bookmarkableId={Number(reviewId)}
            />
            <PhotoModal>
                <PhotoModalContent
                    beforePhotos={reviewInfo.beforePhotos}
                    afterPhotos={reviewInfo.afterPhotos}
                    onCloseClicked={closeModal}
                />
            </PhotoModal>
        </div>
    )
}

export default ReviewDetail;
